import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
var p = document.createElement('link');
p.rel = 'preload';
p.as = 'image';
p.href = 'https://cdn.magicpatterns.com/uploads/aYz2VWHF8Ao3Seb4BsFXiM/EL_BLINDAJE_OPERATIVO_ARCA(Ex-AFIP)_Pack_5_Tomos_2B_Bonos_-_by_Fegion_(1).jpg';
p.setAttribute('fetchpriority', 'high');
document.head.appendChild(p);
render(<App data-id="element-3" />, document.getElementById('root'));